import React from 'react';
import { formatCurrency } from '@/utils/money';
import { Typography, XStack } from '@usepepper/sprout-kit-ui';
import { useSupportInfoMinRowHeight } from '@/experiences/sales-portal/domain/insights/components/alert-card/alert-support-info/constants';
import type { OverduePaymentAlert } from '@/experiences/sales-portal/domain/insights/blocs/types/alert';

const BORDER_WIDTH = 1;

interface OverduePaymentSupportInfoProps {
  alert: OverduePaymentAlert;
}

/** A bordered row for an overdue-payment alert: amount and invoice number. */
export const OverduePaymentSupportInfo: React.FC<
  OverduePaymentSupportInfoProps
> = ({ alert }) => {
  const minRowHeight = useSupportInfoMinRowHeight();

  return (
    <XStack
      alignItems="center"
      borderColor="$borderPrimary"
      borderRadius="$8"
      borderWidth={BORDER_WIDTH}
      justifyContent="space-between"
      minHeight={minRowHeight}
      paddingHorizontal="$12"
      paddingVertical="$8"
    >
      <Typography size="$sm" variant="label">
        {formatCurrency(alert.amount, alert.currencyCode)}
      </Typography>
      <Typography size="$sm">{alert.invoiceNumber}</Typography>
    </XStack>
  );
};
